import React, { Component } from 'react'
import { NavLink } from 'react-router-dom'
import { Trans } from 'react-i18next'
import { Menu, Dropdown, Icon, Image, Button } from 'semantic-ui-react'

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import _ from 'lodash'

import LanguageMenu from './LanguageMenu'
import MessageMenu from './MessageMenu'

class TopMenu extends Component {
  toast = null

  componentDidMount () {
    this.notify()
  }

  notify = () => {
    const { userInfo } = this.props
    const userVerified = userInfo && userInfo.email_verified
    // Show Toast for email_verified users only if not yet shown
    if (!userVerified && !this.toast) {
      this.toast = toast(
        <Trans>Bitte bestätigen Sie Ihre E-Mail-Adresse (Siehe Registrierungs-Mail)!</Trans>,
        { onClose: () => this.toast = null }
      )
    }
  }

  handle_toggle_menu() {
      const { onToggleMenu } = this.props
      onToggleMenu && onToggleMenu()
   }

  render () {
    const { userInfo, lang, onChangeLanguage } = this.props

    const userName = (userInfo && userInfo.nickname) || 'anonymous'
    const userIconUrl = userInfo && userInfo.picture

    const userVerified = userInfo && userInfo.email_verified

    return (
      <Menu className='App-topmenu'>

        <Menu.Item className='burger' icon='content' size='big' as={Button} onClick={() => {this.handle_toggle_menu()}} />
 
        <Menu.Header className='logo' as={NavLink} exact to='/home'>
          <span className='logo-company'>dpa</span>
          <span className='dot'> • </span>
          <span>
            <Trans>API-Portal</Trans>
          </span>
        </Menu.Header>

        { userInfo && userInfo.scopes && _.includes(userInfo.scopes, 'read:messages') ? (
          <MessageMenu />
        ) : null }

        { userInfo ? (
          <Menu.Item as={NavLink} exact to='/contact'><Trans>Kontakt</Trans></Menu.Item>
        ) : null }

        { <LanguageMenu style={{padding: '1em'}} lang={lang} onChangeLanguage={onChangeLanguage} /> }

        { userVerified ? null :
          <Menu.Item style={{paddingRight: '0em'}} size='big' as={Button} onClick={this.notify}>
            <Icon color='yellow' name='warning sign' />
            <ToastContainer
              autoClose={false}
              hideProgressBar={true}
              closeOnClick />
          </ Menu.Item>
        }

        { userInfo ? (
          <Menu.Menu item='true' position='right' >
            <Dropdown style={{padding: '1em'}} trigger={(
              <span className='dropdown-trigger'>
                <span className='username'>{ userName }</span>
                { userIconUrl ? (
                  <Image src={userIconUrl} className='topmenu-usericon' circular />
                ) : (<Icon name='user' />) }
              </span>)}>
              <Dropdown.Menu >
                <Dropdown.Item as={NavLink} exact to='/logout' icon='power' text={<Trans>Abmelden</Trans>} />
              </Dropdown.Menu>
            </Dropdown>
          </Menu.Menu>
        ) : (
          <Menu.Item as={NavLink} exact to='/login'><Icon name='power' /><Trans>Anmelden</Trans></Menu.Item>
        )}
      </Menu>
    )
  }
}

export default TopMenu



// WEBPACK FOOTER //
// ./src/components/TopMenu.js